import _sfc_main from "./component-library114.mjs";
import "./component-library115.mjs";
import normalizeComponent from "./component-library97.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.LinkButton, { staticClass: "play-pause-button", attrs: { "type": "button", "tag": "button", "icon-only": "", "large": _vm.large, "medium": _vm.medium, "primary": _vm.primary, "secondary": _vm.secondary }, on: { "click": _setup.handleClick } }, [_c("svg", { staticClass: "play-pause-button__svg", attrs: { "viewBox": "0 0 24 24", "xmlns": "http://www.w3.org/2000/svg", "xml:space": "preserve", "aria-hidden": "true", "fill": "currentColor" } }, [!_vm.value ? [_c("path", { attrs: { "d": "m3.8 0 18.4 12L3.8 24z", "fill-rule": "nonzero" } })] : [_c("path", { attrs: { "d": "M9 0v24H3V0zm12 0v24h-6V0z", "fill-rule": "nonzero" } })]], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "288206ca",
  null,
  null
);
const PlayPauseButton = __component__.exports;
export {
  PlayPauseButton as default
};
